const REPORT_REDUX_CONSTANT = {
  GET_ACTIVITY_BREAKDOWN_GRAPH_DATA: 'GET_ACTIVITY_BREAKDOWN_GRAPH_DATA',
  GET_PIPELINE_VALUES_GRAPH_DATA: 'GET_PIPELINE_VALUES_GRAPH_DATA',
  GET_CONVERSATION_GRAPH_DATA: 'GET_CONVERSATION_GRAPH_DATA',
  GET_TOTAL_SALES_GRAPH_DATA: 'GET_TOTAL_SALES_GRAPH_DATA',
  RESET_CONVERSATION_GRAPH_DATA: 'RESET_CONVERSATION_GRAPH_DATA',
  RESET_TOTAL_SALES_GRAPH_DATA: 'RESET_TOTAL_SALES_GRAPH_DATA',
};
export default REPORT_REDUX_CONSTANT;
